module.exports = __webpack_public_path__ + "static/media/orange-check.35a5795b.svg";